'use client'

import Image from 'next/image'
import { alpha } from '@mui/material/styles'
import { Grid, IconButton, Box } from '@mui/material'
import { ArrowBackIosNew as ArrowBackIosNewIcon, ArrowForwardIos as ArrowForwardIosIcon } from '@mui/icons-material'

// Types
import type { ThumbnailProps } from '@/types/components/molecules/gallery/thumbnail'

const ThumbnailMolecule = (props: ThumbnailProps) => {
	// Props
	const { image, title, position, onClick } = props

	return (
		<Grid size={2.4}>
			<IconButton
				onClick={onClick}
				sx={{
					width: 1,
					height: { xs: 'calc((100dvw - 56px - 4 * 8px) / 5)', md: 'calc((996px - 4 * 16px) / 5)' },
					p: 0,
					position: 'relative',
					borderRadius: 1,
					color: 'common.white',
					overflow: 'hidden',
					'& .MuiTouchRipple-root .MuiTouchRipple-child': { borderRadius: 1 },
					'& img': {
						width: 1,
						height: 1,
						objectFit: 'cover',
						objectPosition: 'center'
					},
					'& .thumbnail': {
						display: 'inline-flex',
						justifyContent: 'center',
						alignItems: 'center',
						width: 1,
						height: 1,
						position: 'absolute',
						top: 0,
						left: 0,
						bgcolor: alpha('#000', 0.8),
						'& svg': {
							p: 1,
							fontSize: 36,
							color: '#000',
							bgcolor: alpha('#fff', 0.8),
							borderRadius: 4
						}
					}
				}}
			>
				<Image src={image} alt={title} width={184} height={184} />

				{position === 'left' ? (
					<Box className="thumbnail">
						<ArrowBackIosNewIcon />
					</Box>
				) : position === 'right' ? (
					<Box className="thumbnail">
						<ArrowForwardIosIcon />
					</Box>
				) : null}
			</IconButton>
		</Grid>
	)
}

export default ThumbnailMolecule
